<template>
    <div class="search">

        <search-input
            :initial-params="searchParams"
            :is-loading="isLoading"
            v-if="(isModerate == false)"
            enable-advanced-search
            v-on:search="searchHandler"
            v-on:searchCleared="searchCleared"
        />

        <resource-list
            :title="listTitle"
            :is-loading="isLoading"
            :resources="normalizedResources"
            :is-editing="isModerate"
            :show-deleted="showDeleted"
        />

    </div>
</template>

<script>
import SearchInput from './SearchInput';
import ResourceList from './ResourceList';
import axios from 'axios';
import _ from 'lodash';
import BoxResourceTransformer from '../BoxResourceTransformer';

let queryCache = {};

export default {
    data() {
        return {
            isLoading: false,
            searchParams: {},
            listTitle: 'Recently Added',
            resources: [],
            currentPage: 1,
            lastPage: 1,
        };
    },
    components: {
        'search-input': SearchInput,
        'resource-list': ResourceList
    },
    props: {
      'isModerate': Boolean,
      'tags': String,
      showDeleted: {
          type: Boolean,
          default: false
      },
    },
    created() {
        this.applyInitialSearchParams();
    },
    mounted() {
      console.log('showDeleted', this.showDeleted);
        window.onscroll = function(ev) {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                this.getRecentlyAdded(++this.currentPage);

                if (this.currentPage > this.lastPage) {
                  this.currentPage = this.lastPage;
                }
            }
        }.bind(this);
    },
    // mounted() {
    //     window.addEventListener('hashchange', () => this.hashChangeHandler());
    // },
    methods: {
        // hashChangeHandler() {
        //     let params = this.unserializeSearchParams(location.hash);
        //     this.searchParams = params;
        //     this.searchHandler(this.searchParams);
        // },

        searchHandler(searchParams) {
            let params = _.merge(
                {
                    q: '',
                    page: 1,
                    dateBefore: '',
                    dateAfter: '',
                    sourceDomain: '',
                    tags: '',
                    deleted: this.showDeleted,
                },
                searchParams
            );

            this.currentPage = 1;

            if (this.isModerate == true) {
                if (this.showDeleted) {
                  this.listTitle = 'Deleted Entries';
                }
                else {
                  this.listTitle = '';
                }
                this.getRecentlyAdded();
            }
            else if (searchParams.q !== ''
                || searchParams.dateBefore !== ''
                || searchParams.dateAfter !== ''
                || searchParams.sourceDomain !== '') {
              this.getSearchResults(params);
              this.listTitle = 'Search Results';
            } else {
                this.getRecentlyAdded();
                this.listTitle = 'Recently Added';
            }
            // this.resources = mockResults;
        },

        /**
         * trimSearchParams
         *
         * Eliminate empty/default values from the search params.  Returns a new object.
         */
        trimSearchParams(searchParams) {
            return _.omitBy(searchParams, _.isEmpty);
        },

        serializeSearchParams(searchParams) {
            let queryString = [];
            _.forOwn(this.trimSearchParams(searchParams), (value, key) => {
                queryString.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
            });
            return queryString.join('&');
        },

        unserializeSearchParams(queryString) {
            if (queryString[0] === '#') {
                queryString = queryString.substring(1);
            }
            return _.fromPairs(
                _.map(
                    queryString.split('&'),
                    (str) => str.split('=')
                )
            );
        },

        applyInitialSearchParams() {
            let params;
            let hash = window.location.hash;
            if (hash.length > 1) {
                params = this.unserializeSearchParams(hash);
            }
            this.searchParams = _.merge(
                {
                  q:'',
                  dateBefore:'',
                  dateAfter:'',
                  sourceDomain:'',
                  page: this.currentPage,
                  tags: this.tags,
                  deleted: this.showDeleted,
                 },
                params
            );
            this.searchHandler(this.searchParams);
        },

        getSearchResults(searchParams) {
            const cache = this.checkCache(searchParams);
            history.replaceState(searchParams, 'Search', '#' + this.serializeSearchParams(searchParams));
            //window.location = '#' + this.serializeSearchParams(searchParams);

            if (cache !== false) {
              console.log('getSearchResults(): displaying results from cache', searchParams);
                this.showResults(cache.data.resources);
            } else {
              console.log('getSearchResults(): fetching', searchParams);
                this.isLoading = true;
                axios.get('/search', {
                    params: searchParams
                })
                .then(response => {
                    this.storeResponse(searchParams, response);
                    this.showResults(response.data.resources);
                });
            }
        },

        getRecentlyAdded(page = 1) {
            const cache = this.checkCache({type:'recent', 'page': page});
            history.replaceState("", "", window.location.pathname + window.location.search);
            if (cache !== false) { // || page < this.lastPage && this.lastPage != 0) {
              console.log('getRecentlyAdded(): displaying results from cache');
                this.appendResults(cache.data.resources);
            } else {
              console.log('getRecentlyAdded(): fetching'+this.tags, this.isModerate);
              console.log('getRecentlyAdded(): fetching', '&approved='+ (!this.isModerate == true));
                this.isLoading = true;
                axios.get('/list?page='+page
                    +'&approved='+ (!this.isModerate == true)
                    +'&tags='+ this.tags
                    +'&deleted='+ this.showDeleted
                  )
                    .then(response => {
                        this.storeResponse({type:'recent', 'page': page}, response);
                        if (response.data.resources.data !== undefined) {
                          this.appendResults(response.data.resources.data);
                        }
                        else {
                          this.appendResults(response.data.resources);
                        }
                        this.lastPage = response.data.lastPage;
                    });
            }
        },

        searchCleared() {
          this.getRecentlyAdded(1);
          //this.resources = queryCache[Object.keys(queryCache)[0]].data.resources;
          //this.getRecentlyAdded();
        },

        showResults(files) {
            this.isLoading = false;
            this.resources = files;
        },
        appendResults(files) {
            this.isLoading = false;
            this.resources = _.unionWith(this.resources, files, function(a,b) {
              if (a.id === b.id) {
                return true;
              }
              return false;
            });

        },

        createKeyFromQuery(params) {
            return _.flatten(_.toPairs(params)).join(':');
        },

        checkCache(params) {
            const searchKey = this.createKeyFromQuery(params);
            if (!_.has(queryCache, searchKey)) {
                return false;
            } else {
                return queryCache[searchKey];
            }
        },

        storeResponse(params, response) {
            const searchKey = this.createKeyFromQuery(params);
            queryCache[searchKey] = response;
        }
    },
    computed: {
        normalizedResources() {
            return _.map(this.resources, BoxResourceTransformer);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LibrarySearch.vue